exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".common_field_3Qk {\n  margin-bottom: 7px; }\n\n.common_help_3H- {\n  font-size: 11px;\n  color: #888; }\n\n.common_label_jQJ {\n  font-size: 11px;\n  line-height: 11px !important;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  color: #888; }\n\n.common_error_2pF {\n  color: #ff3267; }\n", "", {"version":3,"sources":["/Users/nicolaythafvelin/efoil/logger-webapp/src/ui/form/common.scss"],"names":[],"mappings":"AAIA;EACE,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY,EAAE;;AAEhB;EACE,eAAe,EAAE","file":"common.scss","sourcesContent":[":export {\n  primaryColor: #00bcd4;\n  accentColor: #ff5722; }\n\n.field {\n  margin-bottom: 7px; }\n\n.help {\n  font-size: 11px;\n  color: #888; }\n\n.label {\n  font-size: 11px;\n  line-height: 11px !important;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  color: #888; }\n\n.error {\n  color: #ff3267; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722",
	"field": "common_field_3Qk",
	"help": "common_help_3H-",
	"label": "common_label_jQJ",
	"error": "common_error_2pF"
};